import classNames from "classnames";

import "../../styles/loader.css";

export const Loader = () => {
    return (
        <div className={classNames("loader-bg", 'f-pg')}>
            <div className="loader">
                <img alt="" src="/images/loader.png" width={50} height={50} />
            </div>
        </div>
    )
}